import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";

export const reportFromActivities = async (itvId, ids) => {
  try {
    const { data } = await api.post(`/interventions/${itvId}/reports/from-activities`, { activity_ids: ids });
    if (data.added.length) toast.success(`${data.created ? "Rapportino creato" : "Rapportino aggiornato"}: ${data.number} (+${data.added.length} attività)`);
    if (data.already.length) toast.info(`Già presente nel rapportino: ${data.already.map((x) => `${x.title} (${x.report.number})`).join(", ")}`);
    return data;
  } catch (e) { toast.error(errorMessage(e)); return null; }
};

export const useReportFromActivities = () => {
  const [busy, setBusy] = useState(false);
  const run = async (itvId, ids) => { setBusy(true); const d = await reportFromActivities(itvId, ids); setBusy(false); return d; };
  return [run, busy];
};

export const ReportLink = ({ report, testId }) => (
  <Link to={`/rapportini/${report.id}`} className="text-xs font-semibold text-emerald-700 hover:underline" data-testid={testId}>Nel rapportino {report.number}</Link>
);
